import { UiSchema } from '@rjsf/utils'

import { calculateAreaMeasurementsForMaterial } from '../imup/sagas/2D/createDrawableLocation'
import { FormProperties } from '../imup/types'
import { ActiveDrawable } from '../models/activeDrawable'
import { GeneralDrawableSettings } from '../models/activeDrawableSettings'
import { Region } from '../models/region'
import { DRAWABLE_TYPES } from '../shared/constants/drawable-types'
import { parseScaleFactorLabel } from '../utils/calculations/scaleConversion/scaleConversion'
import { calculateTotalArea } from '../utils/formSchema/formSchema-helper-functions'
import { convertFullNumberFractionToDecimal, truncateToDecimals } from '../utils/formSchema/numberConversion'

const pitchOtherValue = 'other'

const uiSchema: UiSchema = {
    'ui:order': ['type', 'pitch', 'pitch_other', 'roof_sheathing', 'treated', 'fire_rated'],
    type: {
        'ui:placeholder': 'Select Framing Roofing Type',
    },
    roof_sheathing: {
        'ui:placeholder': 'Select Roof Sheathing',
    },
    treated: {
        'ui:title': 'Treated',
        'ui:field': 'SwitchField',
    },
    fire_rated: {
        'ui:title': 'Fire Rated',
        'ui:field': 'SwitchField',
    },
}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.pitch === pitchOtherValue && newSettings.pitch_other) {
        newSettings.pitch =
            convertFullNumberFractionToDecimal(String(newSettings.pitch_other)) ?? newSettings.pitch_other
        newSettings.pitch = truncateToDecimals(newSettings.pitch)

        delete newSettings.pitch_other
    } else if (newSettings.pitch !== pitchOtherValue) {
        newSettings.pitch_other = null
    }

    return newSettings
}

const onValidate = () => {}

/**
 * Augment the drawables of the from based on the new settings
 * @returns
 * @param input
 */
function prepareDrawables(input: {
    drawables: ActiveDrawable[]
    newSettings: GeneralDrawableSettings
    scaleFactor: number
    dpi: number | null
    pdfScale: number
    xCalibrationFactor: number
    yCalibrationFactor: number
    regions: Region[]
    is3D?: boolean
}): ActiveDrawable[] {
    const { drawables, newSettings, scaleFactor, dpi, pdfScale, xCalibrationFactor, yCalibrationFactor, regions } =
        input

    return drawables.map((drawable) => {
        const totalArea: number = calculateTotalArea(
            drawable.opening_locations,
            regions,
            parseScaleFactorLabel(drawable.additional_data.scale_factor) ?? scaleFactor,
            pdfScale,
            xCalibrationFactor,
            yCalibrationFactor,
            dpi
        )

        // Keep area in sync with quantity here too, otherwise area is left frozen at whatever it was
        // computed as (e.g. at creation) while quantity keeps getting refreshed on every settings save,
        // permanently diverging even though nothing about the shape's actual geometry changed.
        drawable.settings.area = totalArea
        drawable.settings.quantity = calculateAreaMeasurementsForMaterial(totalArea, {
            type: DRAWABLE_TYPES.FRAMING_ROOFING,
            settings: newSettings,
        })

        return drawable
    })
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, prepareDrawables }

export default form
